<div
  class="form-input border-2 border-dashed group transition-all delay-100 rounded max-w-[300px]"
  [ngClass]="{
    'p-2 pb-6 border-2 bg-white/0 border-grey-concrete lg:border-white/0 hover:shadow-inner hover:bg-grey-light-concrete/30 hover:scale-95 lg:hover:border-grey-concrete -mt-2.5':
      (permissions?.includes('opportunities_admin') &&
        context == 'opportunities' &&
        !['won', 'lost', 'closed'].includes((opportunity$ | async)?.attributes.opportunity_stage)) ||
      (permissions?.includes('leads_admin') &&
        context == 'leads' &&
        !['converted', 'disqualified'].includes((lead$ | async)?.attributes.lead_stage)) ||
      (context == 'general' && permissions?.includes('customers_upsert')),
  }"
>
  <label>Next Step</label>
  <div>
    @if ((nextStepLoadingState$ | async) !== 'loading' && (nextStep$ | async)) {
      <app-next-step-item [nextStep]="nextStep$ | async"></app-next-step-item>
    }
    @if ((nextStepLoadingState$ | async) !== 'loading' && !(nextStep$ | async)) {
      <div>
        <ion-icon name="flag-outline" class="text-grey-blue/25 mr-1"></ion-icon>
        <span class="font-normal text-empty-field">None</span>
      </div>
    }
  </div>
  <div
    class="absolute flex top-0 md:bottom-0 right-2 w-full items-end transition justify-end -ml-2 lg:opacity-0 lg:group-hover:opacity-100 delay-100"
  >
    @if (
      (permissions?.includes('opportunities_admin') &&
        context == 'opportunities' &&
        !['won', 'lost', 'closed'].includes((opportunity$ | async)?.attributes.opportunity_stage)) ||
      (permissions?.includes('leads_admin') &&
        context == 'leads' &&
        !['converted', 'disqualified'].includes((lead$ | async)?.attributes.lead_stage)) ||
      (context == 'general' && permissions?.includes('customers_upsert'))
    ) {
      <button
        id="update-next-step"
        class="my-2 p-0.5 md:p-2 btn-primary flex backdrop-blur-sm shadow-md bg-primary/20 text-turquoise-mid hover:bg-primary relative z-20 hover:text-white transition"
        (click)="presentNextStepDetailsPopover($event)"
      >
        <ion-icon name="add-outline" class="size-4"></ion-icon>
        <span class="text-xs mr-1 max-sm:hidden">Add</span>
      </button>
    }
  </div>
</div>
